module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/hero_mob-30b4feb7cc42ba50a7076c35f5b37d8e.jpg";